export default "__VITE_ASSET__10143830__"